export default __webpack_public_path__ + "static/media/srcwiz.c6cf0d96.png";